export const handleFeatureFlag = () => {
  const defaultUrlLocations = [
    'https://local-apps.apexclearing.local',
    'https://staging-apps.apexclearing.local',
    'https://dev-apps.apexclearing.local',
    'https://uat-apps.apexclearing.local',
    'https://uat-apps.apexclearing.com',
    'https://uat-public-apps.apexclearing.com'
  ]
  const testUrl = (location: string) => location === window.location.origin

  // This sets the feature for the default urls.
  const isFeature = defaultUrlLocations.some(testUrl)

  // Define the locations separately to make a specific feature available
  // only to certain environments.
  // For example, to add wire transfers to local only:
  //    return {
  //      wire: ['https://local-apps.apexclearing.local'].some(testUrl),
  //      check: isFeature
  //    }

  return {
    positionJournal: isFeature
    // <featureName>: isFeature
  }
}
